import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore/lite";
import { TInterest } from "../models/interests.model";
import { apiWorker, TResponse } from "./apiWorker";

export async function getInterests({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: TResponse<TInterest>) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();

  const publicQuery = query(
    collection(db, "interests"),
    where("public", "==", true)
  );

  const privateQuery = query(
    collection(db, "interests"),
    where("userId", "==", localStorage.getItem("uid"))
  );

  const [publicSnap, privateSnap] = await Promise.all([
    getDocs(publicQuery),
    getDocs(privateQuery),
  ]);

  const allDocs = [...publicSnap.docs, ...privateSnap.docs];

  const data = allDocs.map((doc) => {
    return {
      ...doc.data(),
      id: doc.id,
    };
  }) as TInterest[];

  onSuccess?.({
    content: data,
    total: data.length,
    limit: 0,
    offset: 0,
  });
}

export function createInterest({
  name,
  color,
  onSuccess,
  onError,
}: {
  name: string;
  color: string;
  onSuccess?: (data: TInterest) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    url: `/interests`,
    method: "POST",
    body: { name, color },
    onSuccess,
    onError,
  });
}

export function updateInterest({
  id,
  name,
  color,
  onSuccess,
  onError,
}: {
  id: string;
  name: string;
  color: string;
  onSuccess?: (data: TInterest) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    url: `/interests/${id}`,
    method: "PUT",
    body: { name, color },
    onSuccess,
    onError,
  });
}

export function deleteInterest({
  id,
  onSuccess,
  onError,
}: {
  id: string;
  onSuccess?: (data: TInterest) => void;
  onError?: (data: any) => void;
}) {
  apiWorker({
    url: `/interests/${id}`,
    method: "DELETE",
    onSuccess,
    onError,
  });
}
